module.exports = __webpack_public_path__ + "img/ico_feedback.bf43e89d.svg";